import { useMutation } from "@tanstack/react-query";
import { API } from "../API";
import { ClockInOutCallType, VisitInstanceId } from "../messages";

interface UploadVerificationSelfieParams {
  imageBase64: string;
  visitInstanceId: VisitInstanceId;
  clockType: ClockInOutCallType;
}

interface Props {
  api: API;
}

export const useUploadVerificationSelfieMutation = (props: Props) => {
  return useMutation((params: UploadVerificationSelfieParams) =>
    props.api.uploadClockInOutVerificationImage(params.visitInstanceId, params.clockType, {
      imageBase64: params.imageBase64,
    })
  );
};
